import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  duration,
  pxToRem,
  size,
  width,
} from '@twistopayments/design-system/styles'

export const section = (theme: Theme) => css`
  padding: ${size[24]};
  display: flex;
  flex-direction: column;
  gap: ${size[32]};
  background-color: ${theme.palette.background.main};
  color: ${theme.palette.text.title};

  ${breakpoint.up('smMd')} {
    min-height: ${width.container.tiny};
    gap: ${size[48]};
  }
`

export const content = css`
  margin: 0 auto;
`

export const title = css`
  font-size: ${pxToRem(32)};
  line-height: 1.2;
  max-width: ${width.modal.compact};
  text-align: left;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
    text-align: center;
  }
`

export const subtitle = (theme: Theme) => css`
  color: ${theme.palette.primary.mainContrast};
  text-align: center;
  text-transform: uppercase;
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`

export const list = css`
  max-width: ${width.container.compact};
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${size[4]};
`

export const grid = css`
  ${breakpoint.up('smMd')} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${size[4]};
  }
`

export const formButton = (theme: Theme) => css`
  padding: ${size[8]} ${size[12]};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background-color: ${theme.palette.primary.lowContrast};
  border: none;
  border-radius: ${size[4]};
  font-size: ${pxToRem(16)};
  cursor: pointer;
  transition: all ${duration.standard}ms ease-out;

  &:hover {
    background-color: ${theme.palette.secondary.mediumContrast};
    transition: all ${duration.standard}ms ease-out;
  }

  svg {
    fill: ${theme.palette.primary.mainContrast};
  }

  ${breakpoint.up('smMd')} {
    max-width: 356px;
  }
`

export const buttonContent = css`
  display: flex;
  align-items: center;
  gap: ${size[16]};
`

export const form = css`
  margin: 0 auto;
  max-width: 100%;
  width: 50em;
  height: 500px;
  border: none;
`
